import React, { useState } from "react";

export default function SwitchIOS({ label, toggled, onClick, tooltipName, name = "" }) {
  const [isToggled, toggle] = useState(toggled);
  const callback = () => {
    toggle(!isToggled);
    onClick(!isToggled);
  };
  return (
    <label
      className="relative flex justify-between items-center group text-xl cursor-pointer"
      title={tooltipName}
    >
      {label}
      <input
        type="checkbox"
        defaultChecked={isToggled}
        onClick={callback}
        className="absolute left-1/2 -translate-x-1/2 w-full h-full peer appearance-none rounded-md cursor-pointer"
        name={name}
      />
      <span className="w-11 h-6 flex items-center flex-shrink-0 p-1 bg-gray-300 rounded-full duration-300 ease-in-out peer-checked:bg-green-400 after:w-5 after:h-5 after:bg-white after:rounded-full after:shadow-md after:duration-300 peer-checked:after:translate-x-4 cursor-pointer"></span>
    </label>
  );
}
